import React, {useEffect, useState} from 'react';
import Modal from 'react-bootstrap/Modal';
import {Form} from 'react-bootstrap';
import ButtonCancel from '../../modules/form/ButtonCancel';
import ButtonSubmit from '../../modules/form/ButtonSubmit';
import {useIntl} from 'react-intl';
import Role from '../../classes/api/Role';
import {Customer} from '../../../Domains/Auth/Types/customer';
import {User} from '../../../Domains/Auth/Types/User';
import {useUpdateUserRoles} from '../../../Domains/Auth/Hooks/UserManager';
import RoleSwitchList from './RoleSwitchList';

interface ModalRightEditUserProps {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  user: User;
  roles: Role[];
  customer: Customer;
}

const ModalEditUserRights = ({
  showModal,
  setShowModal,
  user,
  roles,
  customer,
}: ModalRightEditUserProps): JSX.Element => {
  const intl = useIntl();

  const [selectedRoles, setSelectedRoles] = useState<number[]>(
    user.role_user.map((roleUser) => roleUser.role.id)
  );

  useEffect(() => {
    setSelectedRoles(user.role_user.map((roleUser) => roleUser.role.id));
  }, [user]);

  const {mutate} = useUpdateUserRoles();

  const handleUpdate = async (event: React.FormEvent) => {
    event.preventDefault();

    mutate({
      user: user.id,
      entity_id: customer.id,
      system: customer.system,
      roles: selectedRoles,
    });

    setShowModal(false);
  };

  return (
    <>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{intl.formatMessage({id: 'SETTINGS.EDIT.USER'})}</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleUpdate}>
          <Modal.Body>
            <Form.Label>
              {intl.formatMessage({id: 'USER_MANAGER.RIGHTS.ASSIGNED_ROLES'})}
            </Form.Label>
            <RoleSwitchList
              roles={roles}
              selectedRoles={selectedRoles}
              onChange={setSelectedRoles}
              idPrefix="edit-role"
            />
          </Modal.Body>
          <Modal.Footer className="d-flex flex-column align-items-center">
            <div className="d-flex justify-content-center">
              <div className="me-4">
                <ButtonCancel onClick={() => setShowModal(false)} textId="CANCEL" />
              </div>
              <div>
                <ButtonSubmit textId="SAVE" disabled={false} isLoading={false} />
              </div>
            </div>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default ModalEditUserRights;
